

import { db } from "../../config/firebase";
import { collection, query, getDocs, orderBy } from 'firebase/firestore'




const getCountries = async () => {
    const colRef = await collection(db, 'countries');
    const q = query(
        colRef,
        orderBy('name'),
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    return dizi;
}

const countriesService = {
    getCountries,
}

export default countriesService